/* Core & libraries */
import React, { useEffect } from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import { useUserContext } from "../../contexts/userContext";
import { PAGE_TITLES } from "../../constants/appConstants";
import { useAnalytics } from "../../hooks/useAnalytics";

/* Components */
import AirlineProgramsPageHeader from "../../components/airlineProgramsPageHeader";
import AirlineProgramsContent from "../../components/airlineProgramsContent";
import { AIRLINES } from "../../constants/appConstants";

/* Styles */
import styles from "./styles";

const People = () => {
  const theme = useTheme();
  const classes = styles({ theme });
  const userDetails = useUserContext();
  const providerCode = userDetails?.userInfo?.providerInfo?.providerCode;

  const { initAnalytics } = useAnalytics();
  useEffect(() => {
      const initUtagData = {
          channel: 'content',
          pageName: PAGE_TITLES["join"]
      };
      initAnalytics(initUtagData, 'init call', 'view')
  }, []);

  return (
    providerCode === AIRLINES.UC &&
    <div className={ classes.joinPage }>
      <AirlineProgramsPageHeader/>
      <AirlineProgramsContent />
    </div>
  )
}

export default People;
